// Mock data for contact form submissions
export const mockContactSubmission = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Contact Form Submission (Mock):', formData);
  
  return {
    success: true,
    message: 'Thank you for contacting Infiniti Health! We will get back to you within 24 hours.',
    data: formData
  };
};
